module.exports = __webpack_public_path__ + "img/palm-x6-plus-1.98cdcc8b.png";